import { useCounterStore } from "@/store/user";
import { computed } from "vue";
import { useRoute } from "vue-router";
export const useRouterGroup = () => {
    const route = useRoute();
    const useStore = useCounterStore();
    const userInfo = useStore.getUserInfo;
    const workbenchModels = userInfo.type === "master" ? ["container-overview"] : [];
    const resourceModels = userInfo.type === "master" ? ["cluster", "node", "memory", "ssh", "extend", "queue"] : ["cluster", "node", "memory", "ssh",];
    const accountModels = userInfo.type === "master" ? ["personal", "money", "access"] : ["personal"];
    const application = ["mirror", "model", "data-module"];
    const routeList = {
        workbench: {
            label: "",
            value: [],
            includeModel: [workbenchModels]
        },
        resource: {
            label: "资源管理",
            value: [],
            includeModel: [resourceModels]
        },
        application: {
            label: "AI资产",
            value: [],
            includeModel: [application]
        },
        account: {
            label: "账户管理",
            value: [],
            includeModel: [accountModels]
        },
        help: {
            label: "帮助中心",
            value: [],
            includeModel: [["concat", "question"]]
        }
    };
    const findKeyByIncludeModel = (data, target) => {
        for (const key in data) {
            if (data[key].includeModel.some((arr) => arr.includes(target))) {
                return key;
            }
        }
        return "";
    };
    const activeRouterName = computed(() => {
        const value = route.matched[0].name === "log"
            ? userInfo.type === "admin"
                ? "manager"
                : "GPU"
            : findKeyByIncludeModel(routeList, route.matched[0].name);
        return value;
    });
    return { routeList, activeRouterName };
};
